const footer = {
  quickLinks: "快速链接",
  socialMedia: "关注我们",
};

export default footer;